import { ReportDownloadParams } from 'app/common/types/reports/downloadFile'
import type { Request } from '../../index'


type DownloadFileParams = {
  report_id: number,
}

export const convertParams = (params: ReportDownloadParams): [DownloadFileParams, null] => {
  const {
    reportFileID,
  } = params
  const reportID = typeof reportFileID === 'string' ? parseInt(reportFileID, 10) : reportFileID
  return [{ report_id: reportID }, null]
}


export const GET_DOWNLOAD_FILE: Request<
  DownloadFileParams,
  void,
  void
> = ['reports/download_file', 'get', []]

// 422 report error - в процессе формирования файла произошла ошибка
// 422 report is not ready - файл еще не готов
